var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 8,
    fill: "#27AE60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 20.3333L20.3333 13.6667M24.5 17C24.5 21.1421 21.1421 24.5 17 24.5C12.8579 24.5 9.5 21.1421 9.5 17C9.5 12.8579 12.8579 9.5 17 9.5C21.1421 9.5 24.5 12.8579 24.5 17ZM21.1667 19.5C21.1667 20.4205 20.4205 21.1667 19.5 21.1667C18.5795 21.1667 17.8333 20.4205 17.8333 19.5C17.8333 18.5795 18.5795 17.8333 19.5 17.8333C20.4205 17.8333 21.1667 18.5795 21.1667 19.5ZM16.1667 14.5C16.1667 15.4205 15.4205 16.1667 14.5 16.1667C13.5795 16.1667 12.8333 15.4205 12.8333 14.5C12.8333 13.5795 13.5795 12.8333 14.5 12.8333C15.4205 12.8333 16.1667 13.5795 16.1667 14.5Z",
    stroke: "#D9EDB0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterest);
export default __webpack_public_path__ + "static/media/interest.24d3d6a41370df738922f644b5830e9f.svg";
export { ForwardRef as ReactComponent };